const helocRules = [
  { minCredit: 740, maxLtv: 89.9, maxAmount: 250000 },
  { minCredit: 740, maxLtv: 80, maxAmount: 500000 },
  { minCredit: 700, maxLtv: 89.9, maxAmount: 250000 },
  { minCredit: 700, maxLtv: 80, maxAmount: 500000 },
  { minCredit: 660, maxLtv: 89.9, maxAmount: 250000 },
  { minCredit: 620, maxLtv: 89.9, maxAmount: 100000 },
];

const appraisalRules = [
  {
    minCredit: 700, minLtv: 60, minAppraisalAmt: 299999, appraisalCost: 650,
  },
  {
    minCredit: 700, mixLtv: 1, minAppraisalAmt: 399999, appraisalCost: 650,
  },
  {
    minCredit: 620, minLtv: 80, minAppraisalAmt: 1, appraisalCost: 650,
  },
  {
    minCredit: 620, mixLtv: 1, minAppraisalAmt: 249999, appraisalCost: 650,
  },
];

const heloanRules = [
  { minCredit: 700, maxLtv: 89.9, maxAmount: 250000 },
  { minCredit: 700, maxLtv: 80, maxAmount: 500000 },
  { minCredit: 660, maxLtv: 89.9, maxAmount: 250000 },
  { minCredit: 660, maxLtv: 65, maxAmount: 250000 },
];

const secondHomeHelocRules = [
  { minCredit: 700, maxLtv: 80, maxAmount: 500000 },
];

const secondHomeHeloanRules = [
  { minCredit: 740, maxLtv: 89.9, maxAmount: 250000 },
  { minCredit: 740, maxLtv: 80, maxAmount: 500000 },
  { minCredit: 700, maxLtv: 80, maxAmount: 500000 },
  { minCredit: 660, maxLtv: 75, maxAmount: 250000 },
];

const investmentHelocRules = [
  { minCredit: 720, maxLtv: 75, maxAmount: 250000 },
  { minCredit: 680, maxLtv: 75, maxAmount: 100000 },
  { minCredit: 680, maxLtv: 70, maxAmount: 250000 },
];

const investmentHeloanRules = [
  { minCredit: 0, maxLtv: 100, maxAmount: 0 },
];

export function determineHelocAmount(userCredit, ltv, cashRequested, type, loanAmount, occupancy) {
  let selectedRules;
  switch (type) {
    case 'HELOC': {
      if (occupancy === 'Primary residence') {
        selectedRules = helocRules;
      } else if (occupancy === 'Vacation home') {
        selectedRules = secondHomeHelocRules;
      } else {
        selectedRules = investmentHelocRules;
      }
      break;
    }
    case 'HELOAN': {
      if (occupancy === 'Primary residence') {
        selectedRules = heloanRules;
      } else if (occupancy === 'Vacation home') {
        selectedRules = secondHomeHeloanRules;
      } else {
        selectedRules = investmentHeloanRules;
      }
      break;
    }
    default:
      selectedRules = helocRules;
  }
  const rule = selectedRules.find((r) => userCredit >= r.minCredit && ltv <= r.maxLtv && cashRequested <= r.maxAmount);
  const appraisal = appraisalRules.find((r) => userCredit >= r.minCredit && ltv >= r.minLtv && cashRequested > r.minAppraisalAmt);
  const selectedRule = rule ? Math.min(rule.maxAmount, cashRequested) : 0;
  const appraisalCost = appraisal && appraisal !== undefined ? appraisal.appraisalCost : 0;
  return [selectedRule, appraisalCost];
}
